// Heights are CSS pixels measured after fonts load, never character estimates.
export const paginateReportFlow = ({ sections, firstTop, nextTop, bottom, gap = 8 }) => {
  if (!(bottom > firstTop && bottom > nextTop)) throw new Error('พื้นที่ Flow ไม่ถูกต้อง')
  const pages = [[]]
  let top = firstTop
  const nextPage = () => {
    if (pages.length >= 100) throw new Error('รายงานเกิน 100 หน้า กรุณาตรวจข้อมูล')
    pages.push([])
    top = nextTop
  }
  for (const section of sections) {
    // A repeated clinical record must never share a page with the previous
    // record. Continuation pages still belong to the same record/header.
    if (section.startNewPage && pages[pages.length - 1].length) {
      nextPage()
      top = firstTop
    }
    const recordContext = section.groupId === undefined ? {} : { groupId: section.groupId }
    let pending = [...section.blocks]
    let continued = false
    if (!pending.length) pending = ['']
    while (pending.length) {
      const title = continued ? `${section.title || ''} (ต่อ)`.trim() : section.title
      const fullHeight = section.measure(pending, title)
      if (section.mode === 'keep') {
        if (fullHeight > bottom - nextTop) throw new Error('กลุ่มที่ห้ามแบ่งยาวเกินหนึ่งหน้า กรุณาแยกกลุ่ม')
        if (top + fullHeight > bottom) nextPage()
        pages[pages.length - 1].push({ id: section.id, top, title, blocks: pending, height: fullHeight, ...recordContext })
        top += fullHeight + gap
        pending = []
        continue
      }
      const accepted = []
      while (pending.length && top + section.measure([...accepted, pending[0]], title) <= bottom) {
        accepted.push(pending.shift())
      }
      if (!accepted.length) {
        // Keep a normal medication/paragraph together; split only a block that
        // cannot fit even on a fresh page. The splitter uses measured HTML.
        if (section.measure([pending[0]], title) <= bottom - nextTop) {
          nextPage()
          continue
        }
        const parts = section.split(pending[0], bottom - top, title)
        if (!parts) {
          if (top === nextTop) throw new Error('ไม่สามารถแบ่งข้อความให้พอดีหน้ากระดาษ')
          nextPage()
          continue
        }
        accepted.push(parts[0])
        pending[0] = parts[1]
      }
      const height = section.measure(accepted, title)
      pages[pages.length - 1].push({ id: section.id, top, title, blocks: accepted, height, ...recordContext })
      top += height + gap
      if (pending.length) {
        continued = true
        nextPage()
      }
    }
  }
  return pages
}

export const getReportFlowGroups = (dataSourceList = [], repeatDataSourceId) => {
  if (repeatDataSourceId === undefined || repeatDataSourceId === null || repeatDataSourceId === '') {
    return [{ id: 'single', dataSourceList }]
  }
  const source = dataSourceList.find((item) => String(item.dataSourceId) === String(repeatDataSourceId))
  if (!source) throw new Error('ไม่พบ datasource สำหรับบันทึกที่ต้องจัดหน้าซ้ำ')
  const rows = source.fieldVariable?.value
  if (!Array.isArray(rows) || !rows.length) throw new Error('ไม่พบรายการบันทึกสำหรับรายงาน')
  if (rows.some((row) => !row || typeof row !== 'object' || Array.isArray(row))) {
    throw new Error('ข้อมูลบันทึกสำหรับรายงานไม่ถูกต้อง')
  }
  return rows.map((row, index) => ({
    id: `record-${index}`,
    dataSourceList: dataSourceList.map((item) => item === source
      ? { ...item, fieldVariable: { ...item.fieldVariable, value: [row] } }
      : item),
  }))
}

export const hasReportFlow = (boxes = {}) =>
  Object.values(boxes || {}).some((item) => item?.type === 'texteditor' && ['split', 'keep'].includes(item.flowMode))
